export default __webpack_public_path__ + "static/bbeari-12a25ae904169550582a15d84e9217a7.jpg";